import { useTranslation } from 'react-i18next';
import { z } from 'zod';

const MAX_NAME_LENGTH = 255;

export const useUpdateSpaceGroupNameFormValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  const schema = z.object({
    name: z
      .string()
      .min(1, t('validation:required'))
      .max(
        MAX_NAME_LENGTH,
        t('validation:maxCharacters', { count: MAX_NAME_LENGTH }),
      ),
  });

  return schema;
};
